$(document).ready(function () {
  var $slider = $(".commmunity-slider");
  if (
      $slider.length &&
      $slider.children('div').filter(function () {
        return $(this).children().length > 0;
      }).length > 1
    ) 
   {
    if ($slider.hasClass("slick-initialized")) {
      $slider.slick("unslick");
    }
    $slider.slick({
      slidesToShow: 8,
      slidesToScroll: 1,
      autoplaySpeed: 5000,
      autoplay: true,
      dots: false,
      arrows: false,
      infinite: true,
      centerMode: true,
      centerPadding: "7%",
      swipeToSlide: true,
      rtl: false, 
      responsive: [
        {
          breakpoint: 2100,
          settings: {
            slidesToShow: 6,
            slidesToScroll: 1,
            centerPadding: "10%",
          },
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            centerPadding: "10%",
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2.3,
            slidesToScroll: 1,
            infinite: false,
            autoplay: true,
            centerMode: false,
            centerPadding: "0%",
          },
        },
      ],
    });
  }
});
